// lodash
import get from 'lodash.get'
import isEmpty from 'lodash.isempty'
import isPlainObject from 'lodash.isplainobject'
import pick from 'lodash.pick'
import range from 'lodash.range'
import sortBy from 'lodash.sortby'
import throttle from 'lodash.throttle'

// superlanding
import commaSeparate from '@superlanding/commaseparate'
import getApStr from '@superlanding/getapstr'
import getDomPos from '@superlanding/getdompos'
import getScrollLeft from '@superlanding/getscrollleft'
import getScrollTop from '@superlanding/getscrolltop'
import isClient from '@superlanding/isclient'
import isServer from '@superlanding/isserver'
import mapDispatch from '@superlanding/mapdispatch'
import toPixel from '@superlanding/topixel'
import toPromise from '@superlanding/topromise'

// redux
import { connect } from 'redux-vuex'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { combineEpics, createEpicMiddleware, ofType } from 'redux-observable'

// rxjs
import { defer, of, from } from 'rxjs'
import {
  catchError,
  delay,
  exhaustMap,
  map,
  retryWhen,
  takeWhile,
  tap
} from 'rxjs/operators'

// others
import anchorMe from 'anchorme'
import animateScrollTo from 'animated-scroll-to'
import { parse as parseUrl } from 'url'
import uuid from 'uuid/v4'
import { zh } from 'vuejs-datepicker/dist/locale'
import ClientOnly from 'vue-client-only'
import { DateTime } from 'luxon'
import { PulseLoader } from '@saeris/vue-spinners'
import Router from 'vue-router'

export {
  // lodash
  get,
  isEmpty,
  isPlainObject,
  pick,
  range,
  sortBy,
  throttle,

  // superlanding
  commaSeparate,
  getApStr,
  getDomPos,
  getScrollLeft,
  getScrollTop,
  isClient,
  isServer,
  mapDispatch,
  toPixel,
  toPromise,

  // redux
  applyMiddleware,
  connect,
  combineEpics,
  combineReducers,
  createEpicMiddleware,
  createStore,
  ofType,

  // rxjs
  defer,
  of,
  from,
  catchError,
  delay,
  exhaustMap,
  map,
  retryWhen,
  takeWhile,
  tap,

  // others
  anchorMe,
  animateScrollTo,
  parseUrl,
  uuid,
  zh,
  ClientOnly,
  DateTime,
  PulseLoader,
  Router
}
